<div class="modal-header">
    <h4 class="modal-title">Medical Certificate</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div>
        <form [formGroup]="certForm">
          <!-- Header Section -->
          <!-- <div class="header">
            <div class="logo-title">JSK HEALTHCARE</div>
            <div class="logo-sub">INSPIRED INNOVATIONS, IMPROVING LIVES</div>
            
            <div class="registration-info">
              Company Reg No: 2018/601658/07 &nbsp;&nbsp;|&nbsp;&nbsp; Practice No: {{ doctorDetails?.bhf_practice_number || '' }}
            </div>
            <div class="contact-info">
              Address: {{ orgDetails?.main_address || '' }} &nbsp;&nbsp; Phone: {{ orgDetails?.primary_contact_no || '' }} {{ orgDetails?.alternate_contact_no || '' }}
            </div>
          </div> -->
      
          <!-- Date Line -->
         
      
          <!-- <hr class="blue-divider" /> -->
      
          <!-- Title -->
          <h2 class="document-title">MEDICAL CERTIFICATE</h2>

           <div class="date-row">
            <label for="date">Date:</label>
            <input id="date" type="text" formControlName="date" class="line-input short-input" />
          </div>
      
          <!-- Patient Details -->
          <div class="patient-details-row">
            <label for="patientName">Patient Name:</label>
            <input id="patientName" type="text" formControlName="patientName" class="line-input patient-name-input" />
            <label for="dob">D.O.B:</label>
            <input id="dob" type="date" formControlName="dob" class="line-input medium-input" />
            <label for="tel">Tel:</label>
            <input id="tel" type="tel" formControlName="tel" class="line-input medium-input" />
          </div>
      
          <div class="form-row inline-row address-row">
            <label for="patientAddress">Patient Address:</label>
            <input id="patientAddress" type="text" formControlName="patientAddress"
              class="line-input long-input" />
          </div>
      
          <!-- Statement Section -->
          <div class="form-row inline-row statement-row unfit-row">
            <span>This is to certify that the above-mentioned patient was examined at this practice on:<span class="text-danger">*</span></span>
            <input id="examinationDate" name="examinationDate" type="text" autocomplete="off" onpaste="return false"
               bsDatepicker #examinationDp="bsDatepicker" 
              formControlName="examinationDate" [minDate]="todayDate" (bsValueChange)="onExaminationDateChange($event)"
              onkeypress="return event.charCode == 8"
              [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false,adaptivePosition: true,isAnimated: true  }"
              class="line-input medium-input" />.
          </div>
      
          <div class="form-row inline-row statement-row">
            <span>In my professional opinion, the patient is / was medically unfit for work / school from:<span class="text-danger">*</span></span>
            <input id="unfitFrom" name="unfitFrom" type="text" autocomplete="off" onpaste="return false"
               bsDatepicker #unfitFromDp="bsDatepicker" 
              formControlName="unfitFrom" [minDate]="unfitFromMinDate" (bsValueChange)="onUnfitFromChange($event)"
              onkeypress="return event.charCode == 8"
              [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false ,adaptivePosition: true,isAnimated: true }"
              class="line-input medium-input" /><br>
            <span>to:<span class="text-danger">*</span></span>
            <input id="unfitTo" name="unfitTo" type="text" autocomplete="off" onpaste="return false"
               bsDatepicker #unfitToDp="bsDatepicker" 
              formControlName="unfitTo" [minDate]="unfitToMinDate" (bsValueChange)="onUnfitToChange($event)"
              onkeypress="return event.charCode == 8"
              [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false,adaptivePosition: true,isAnimated: true }"
              class="line-input medium-input" />
            <span>(inclusive).</span>
          </div>
      
          <div class="form-row inline-row statement-row">
            <span>The patient may return to work / school on:<span class="text-danger">*</span></span>
            <input id="returnDate" name="returnDate" type="text" autocomplete="off" onpaste="return false"
               bsDatepicker #returnDateDp="bsDatepicker"
              formControlName="returnDate" [minDate]="returnDateMinDate"
              onkeypress="return event.charCode == 8"
              [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false,adaptivePosition: true,isAnimated: true }"
              class="line-input medium-input" />.
          </div>
      
          <div class="form-row inline-row statement-row">
            <label for="employerOrSchool">Employer / School :</label>
            <input id="employerOrSchool" type="text" formControlName="employerOrSchool" class="line-input long-input" />.
          </div>
      
          <div class="form-row inline-row statement-row">
            <label for="diagnosis">Diagnosis / Clinical Notes :</label>
            <input id="diagnosis" type="text" formControlName="diagnosis" class="line-input long-input" />
          </div>
      
          <!-- Practitioner & Signature -->
          <div class="practitioner-grid">
            <div class="form-row inline-row">
              <label for="practitionerName">Practitioner's Name:</label>
              <input id="practitionerName" type="text" formControlName="practitionerName" class="line-input medium-input" />
            </div>
      
            <div class="form-row inline-row">
              <label for="regNo">Reg No:</label>
              <input id="regNo" type="text" formControlName="regNo" class="line-input medium-input" />
            </div>
          </div>
      
          <!-- <div class="form-row inline-row signature-row">
            <label for="signature">Dr Signature:</label>
            <img *ngIf="certForm.get('signature')?.value" [src]="certForm.get('signature')?.value"
              alt="Doctor signature" class="doctor-signature" />
          </div> -->
      
          <!-- <hr class="blue-divider footer-divider" /> -->
          
        </form>
      </div>
</div>

<div class="modal-footer">
    <button type="submit" class="btn btn-sm btn-primary" [disabled]="!certForm.valid" (click)="onSubmit()">Submit</button>
    <button type="button" class="btn btn-sm btn-outline-dark" (click)="closeModal()">Close</button>
</div>
